/**
 * props:
 * - memory ([{key, index, current, previous}])
 * - emptyText (message shown when there is no data in the memory)
 */
function formatValue(value) {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return '-';
    if (typeof value === 'number')
        return value.toLocaleString('en-US', {
            maximumFractionDigits: 8,
        });
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return `${value}`;
}

function flattenObject(ob, prefix = '') {
    return Object.entries(ob || {}).reduce((flat, [key, value]) => {
        const path = prefix ? `${prefix}.${key}` : key;
        if (value && typeof value === 'object' && !Array.isArray(value))
            return { ...flat, ...flattenObject(value, path) };
        return { ...flat, [path]: value };
    }, {});
}

function getTrendArrow(currentValue, previousValue) {
    if (typeof currentValue !== 'number' || typeof previousValue !== 'number')
        return '';
    if (currentValue > previousValue)
        return <span className="text-success">&#9650;</span>;
    if (currentValue < previousValue)
        return <span className="text-danger">&#9660;</span>;
    return '';
}

/**
 * props:
 * - entry ({key, index, current, previous})
 */
function MemoryEntryRow(props) {
    const { entry } = props;
    const currentValue = entry.current;
    const previousValue = entry.previous;

    const arrow = getTrendArrow(currentValue, previousValue);

    const currentText =
        currentValue && typeof currentValue === 'object'
            ? null
            : formatValue(currentValue);

    return (
        <tr>
            <td className="text-gray-800">{entry.index}</td>
            <td>
                {currentText !== null ? (
                    <strong>{currentText}</strong>
                ) : (
                    <div className="row">
                        {Object.entries(flattenObject(currentValue)).map(
                            ([field, value]) => (
                                <div className="col-md-3" key={field}>
                                    <small className="text-gray-500">
                                        {field}
                                    </small>
                                    <div>
                                        <strong>{formatValue(value)}</strong>
                                    </div>
                                </div>
                            ),
                        )}
                    </div>
                )}
            </td>
            <td className="text-gray-600">{formatValue(previousValue)}</td>
            <td>{arrow}</td>
        </tr>
    );
}

function MemoryTable(props) {
    const memory = props.memory || [];
    const hasData = memory.some(
        entry => entry.current !== null && entry.current !== undefined,
    );

    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="card border-0 shadow">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h2 className="fs-5 fw-0 bold">Current data</h2>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        {!hasData ? (
                            <p className="text-gray-600 mb-0">
                                {props.emptyText}
                            </p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th
                                                className="border-bottom"
                                                scope="col"
                                            >
                                                Index
                                            </th>
                                            <th
                                                className="border-bottom"
                                                scope="col"
                                            >
                                                Current
                                            </th>
                                            <th
                                                className="border-bottom"
                                                scope="col"
                                            >
                                                Previous
                                            </th>
                                            <th
                                                className="border-bottom"
                                                scope="col"
                                            ></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {memory.map(entry => (
                                            <MemoryEntryRow
                                                entry={entry}
                                                key={entry.key}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MemoryTable;
